<template>
  <el-container direction="vertical" class="base-container-fixed">
    <Header @editPwd="showPwdForm = true">
      <el-menu
        v-if="
          theme.navStyle == 'top' ||
          theme.navStyle == 'topleft' ||
          theme.navStyle == 'topright'
        "
        mode="horizontal"
        background-color="#3C3C3C"
        text-color="#C4C4C4"
        active-text-color="#ffd04b"
        style="border: none"
      >
        <template v-for="(item, index) in menus">
          <el-menu-item
            :index="item.code"
            :key="index"
            @click="navTopMenu(item)"
          >
            <i v-if="!item.icon" :class="item.icon"></i>
            <span v-text="item.name"></span>
          </el-menu-item>
        </template>
      </el-menu>

      <ArtisanMenu
        mode="horizontal"
        background-color="#1989FA"
        text-color="#ffffff"
        active-text-color="#ffffff"
        style="border: none;display:flex;"
        v-else-if="theme.navStyle == 'toptree'"
        :menus="menus"
        @click="navTab"
      ></ArtisanMenu>
    </Header>
    <ArtisanTabs style="flex: 1;" :style="tabStyle"></ArtisanTabs>
    <artisan-dialog
      ref="editPwdDialog"
      title="修改密码"
      width="700px"
      height="300px"
      :visible.sync="showPwdForm"
      v-loading="isFormLoading"
    >
      <el-form
        ref="editPwdForm"
        label-width="100px"
        :rules="rules"
        size="mini"
        :model="formData"
      >
        <el-row style="margin-top: 20px">
          <el-col :span="12" :offset="6">
            <el-form-item label="原密码" prop="oldPwd">
              <el-input
                type="password"
                v-model="formData.oldPwd"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="6">
            <el-form-item label="新密码" prop="newPwd">
              <el-input
                type="password"
                v-model="formData.newPwd"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="6">
            <el-form-item label="确认新密码" prop="confirmPwd">
              <el-input
                type="password"
                v-model="formData.confirmPwd"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button type="primary" size="mini" @click="editPwd">保存</el-button>
      </template>
    </artisan-dialog>
    <el-drawer
      :modal="false"
      title="主题设置"
      :visible.sync="drawer"
      direction="rtl"
      size="20%"
    >
      测试
    </el-drawer>
  </el-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { isNullOrEmpty } from "@/util/util";
import { removeToken } from "@/util/auth";
import { editPwd } from "@/api/sys/user";
import ArtisanTabs from "./ArtisanTabs";
import Header from "./Header";
import ArtisanMenu from "@/components/ArtisanMenu.vue";
export default {
  components: {
    ArtisanTabs,
    ArtisanMenu,
    Header,
  },
  name: "index",
  provide() {
    return {
      index: this,
    };
  },
  data() {
    let validConfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formData.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      topMenu: "",
      isCollapse: false,
      asideMenuActive: "",
      showPwdForm: false,
      isFormLoading: false,
      drawer: false,
      tenant: {},
      formData: {
        oldPwd: "",
        confirmPwd: "",
        newPwd: "",
      },
      rules: {
        oldPwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        confirmPwd: [
          { required: true, message: "请再次确认新密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
          { validator: validConfirmPwd, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["tabList", "menus", "user", "theme"]),
    tabStyle() {
      if (
        this.theme.navStyle == "topleft" ||
        this.theme.navStyle == "leftleft" ||
        this.theme.navStyle == "lefttree"
      ) {
        return { paddingLeft: this.isCollapse ? "64px" : "200px" };
      } else {
        return {};
      }
    },
    topMenuTitle() {
      if (this.topMenu) {
        return this.topMenu.name;
      }
      return "";
    },
    asideTitleStyle() {
      let style = {};
      if (this.isCollapse) {
        style.textAlign = "center";
      }
      return style;
    },
    collapseBtnStyle() {
      let style = { fontSize: "22px", padding: "9px 5px", color: "#fff" };
      if (!this.isCollapse) {
        style.float = "right";
      }
      return style;
    },
  },
  created() {
    const query = this.$route.query;
    if (query && query.path && query.name) {
      this.addTab({
        name: query.name,
        url: query.path,
      });
    }
    this.getUserMenus().then((res) => {
      for (let i = 0; i < this.menus.length; i++) {
        const item = this.menus[i];
        if (!isNullOrEmpty(item.children)) {
          this.topMenu = item;
          break;
        }
      }
    });
  },
  methods: {
    ...mapMutations(["addTab"]),
    ...mapActions(["getUser", "getUserMenus"]),
    isNullOrEmpty,
    navTopMenu(item) {
      if (isNullOrEmpty(item.children)) {
        this.asideMenuActive = item.code;
        this.addTab({
          name: item.name,
          icon: item.icon,
          url: item.url,
        });
      } else {
        this.topMenu = item;
      }
    },
    navTab(item) {
      this.addTab({
        name: item.name,
        icon: item.icon,
        url: item.url,
      });
    },
    setTheme() {},

    editPwd() {
      this.$refs.editPwdForm.validate((valid) => {
        if (valid) {
          this.$refs.editPwdDialog.confirm({
            msg: "确认修改密码",
            confirm: () => {
              this.isFormLoading = true;
              editPwd(this.formData.oldPwd, this.formData.newPwd).then(
                (res) => {
                  removeToken();
                  this.$router.push({
                    path: "/login",
                  });
                }
              );
            },
          });
        }
      });
    },
  },
};
</script>
<style scoped>
</style>